import {FormConfiguration} from "../../../advanced-form/form-configuration.type";
import {Keyword} from "../../../domain/entities/keyword.entity";

export const keywordFormSettings: FormConfiguration<Keyword>[] = [
    {
        key: `key`,
        type: String,
        label: `Name`,
        initialValue: ``,
        validators: []
    },
    {
        key: `shortcut`,
        type: String,
        initialValue: ``,
        label: `Kürzel`,
        validators: []
    },
    {
        key: `color`,
        type: String,
        initialValue: `#FFFFFF`,
        validators: [],
        label: `Farbe`
    },
    {
        key: `textColor`,
        type: String,
        initialValue: null,
        validators: [],
        label: `Schriftfarbe`
    },
]